import axiosInstance from "../../api/axios";

const AfrService = {
  /**
   * @param {{ incomeId?: number|string, isrcLimit?: number, incomeLimit?: number, orphanLimit?: number }} options
   */
  getOverview: async (options = {}) => {
    const params = new URLSearchParams();

    if (options.incomeId) {
      params.set("income_id", String(options.incomeId));
    }
    if (options.isrcLimit) {
      params.set("isrc_limit", String(options.isrcLimit));
    }
    if (options.incomeLimit) {
      params.set("income_limit", String(options.incomeLimit));
    }
    if (options.orphanLimit) {
      params.set("orphan_limit", String(options.orphanLimit));
    }
    if (options.refresh) {
      params.set("refresh", "1");
    }

    const query = params.toString();
    const url = query ? `/monitoring/afr?${query}` : "/monitoring/afr";
    const response = await axiosInstance.get(url, { timeout: 90000 });
    return response.data;
  },
};

export default AfrService;
